import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShellComponent } from './shell.component';
import { AuthenticationGuard } from '@app/core';
import { PermissionsGuard } from '@app/core/permissions/permissions.guard';

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('../loading/loading.module').then(m => m.LoadingModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule),
        data: {
          permissionsKeys: [{ key: 'read-dashboard' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'jaddah-map',
        loadChildren: () => import('../jaddah-map/jaddah-map.module').then(m => m.JaddahMapModule),
        data: {
          permissionsKeys: [{ key: 'read-dashboard' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'districts',
        loadChildren: () => import('../districts/districts.module').then(m => m.DistrictsModule),
        data: {
          permissionsKeys: [{ key: 'read-district' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'units',
        loadChildren: () => import('../units/units.module').then(m => m.UnitsModule),
        data: {
          permissionsKeys: [{ key: 'read-unit' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'contractors',
        loadChildren: () => import('../contractors/contractors.module').then(m => m.ContractorsModule),
        data: {
          permissionsKeys: [{ key: 'read-contractor' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'waste-types',
        loadChildren: () => import('../waste-type/waste-type.module').then(m => m.WasteTypeModule),
        data: {
          permissionsKeys: [{ key: 'read-waste-type' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'devices',
        loadChildren: () => import('../devices/devices.module').then(m => m.DevicesModule),
        data: {
          permissionsKeys: [{ key: 'read-device' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'damaged-projects',
        loadChildren: () => import('../damaged-projects/damaged-projects.module').then(m => m.DamagedProjectsModule),
        data: {
          permissionsKeys: [{ key: 'read-damaged-project' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'users',
        loadChildren: () => import('../users-feature/users.module').then(m => m.UsersModule),
        data: {
          permissionsKeys: [{ key: 'read-user' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'roles',
        loadChildren: () => import('../roles/roles.module').then(m => m.RolesModule),
        data: {
          permissionsKeys: [{ key: 'read-role' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'permissions',
        loadChildren: () => import('../permissions/permissions.module').then(m => m.PermissionsModule),
        data: {
          permissionsKeys: [{ key: 'read-permission' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'profile',
        loadChildren: () => import('../profile-feature/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'unit-type',
        loadChildren: () => import('../unit-type/unit-type.module').then(m => m.UnitTypeModule),
        data: {
          permissionsKeys: [{ key: 'read-unit-type' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'contracts',
        loadChildren: () => import('../contracts/contracts.module').then(m => m.ContractsModule),
        data: {
          permissionsKeys: [{ key: 'read-contract' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'scales',
        loadChildren: () => import('../scales/scales.module').then(m => m.ScalesModule),
        data: {
          permissionsKeys: [{ key: 'read-scale' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'zones',
        loadChildren: () => import('../zones/zones.module').then(m => m.ZonesModule),
        data: {
          permissionsKeys: [{ key: 'read-zone' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'transitional-station',
        loadChildren: () =>
          import('../transition-station/transition-station.module').then(m => m.TransitionStationModule),
        data: {
          permissionsKeys: [{ key: 'read-transitional-station' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'entrance_permission',
        loadChildren: () =>
          import('../entrance_permission/entrance_permission.module').then(m => m.EntrancePermissionModule),
        data: {
          permissionsKeys: [{ key: 'read-entrance' }]
        },
        canActivate: [PermissionsGuard]
      },
      // {
      //   path: 'activity-log',
      //   loadChildren: () => import('../activity-log/activity-log.module').then(m => m.ActivityLogModule),
      //   data: {
      //     permissionsKeys: [{ key: 'read-dashboard' }]
      //   },
      //   canActivate: [PermissionsGuard]
      // },
      {
        path: 'geofences',
        loadChildren: () => import('../geofences/geofences.module').then(m => m.GeofencesModule),
        data: {
          permissionsKeys: [{ key: 'read-geofence' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'inspector',
        loadChildren: () => import('../inspector/inspector.module').then(m => m.InspectorModule),
        data: {
          permissionsKeys: [{ key: 'read-inspector' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: 'reports',
        loadChildren: () => import('../side-menu-reports/side-menu-reports.module').then(m => m.SideMenuReportsModule),
        data: {
          permissionsKeys: [{ key: 'read-dashboard' }]
        },
        canActivate: [PermissionsGuard]
      },
      {
        path: '401',
        loadChildren: () => import('../401/unauthorized.module').then(m => m.UnauthorizedModule)
      },
      {
        path: '**',
        loadChildren: () => import('../loading/loading.module').then(m => m.LoadingModule),
        data: {
          breadcrumb: 'loading.title'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShellRoutingModule {}
